import React from 'react';
import ReportTechnicalDifficulties from 'components/Practice/Audio/ReportTechnicalDifficulties';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const SkippedOption = ({
  skipRecording,
  disabled,
  showTechnicalDifficulties,
  i18n,
}) => {
  if (showTechnicalDifficulties) {
    return (
      <ReportTechnicalDifficulties
        skipRecording={skipRecording}
        disabled={disabled}
      />
    );
  }

  return (
    <div className="Response-skipped">
      <Text className="mr-4" variant={TEXT_VARIANTS.BODY_LIGHT}>
        {i18n.video_response.cannot_record}
      </Text>
      <button
        type="button"
        className="u-linkBtn"
        onClick={skipRecording}
        disabled={disabled}
      >
        <Text variant={TEXT_VARIANTS.BODY_LINK}>
          {i18n.video_response.skip_action}
        </Text>
      </button>
    </div>
  );
};

export default SkippedOption;
